export enum RequestStatus {
  Ready = 'ready',
  Pending = 'pending',
  Success = 'success',
  Error = 'error',
}

export default RequestStatus;
